// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterImages45_root__3WfpJ","title":"AfterImages45_title__1XM9A","images":"AfterImages45_images__2s5ak"};